import { useAuth } from '../context/AuthContext';
import { browserTz } from '../lib/orgTime';

// Organisation home timezone for timestamps; falls back to the viewer's device zone.
export function useOrgTz() {
  const { orgTz } = useAuth();
  return orgTz || browserTz();
}
